import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import Header from './common/Header';
import Footer from './common/Footer';
import SEO from '../components/common/SEO';
import './blogs.css';

const BlogDetail = () => {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

    useEffect(() => {
        const fetchBlogDetail = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${API_BASE_URL}/blogs/slug/${slug}`);
                if (response.data.success) {
                    setBlog(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching blog details:", error);
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            fetchBlogDetail();
        }
        window.scrollTo(0, 0);
    }, [slug]);

    // Use a wrapper with min-height and padding to clear the fixed header and push the footer down
    const layoutStyle = { minHeight: '60vh', paddingTop: '120px' };

    if (loading) {
        return (
            <div className="main-wrapper">
                <Header />
                <div className="text-center" style={layoutStyle}>
                    <div className="spinner-border text-danger" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    if (!blog) {
        return (
            <div className="main-wrapper">
                <Header />
                <div className="container text-center" style={layoutStyle}>
                    <h2>Blog not found.</h2>
                    <p className="text-muted mt-3 mb-4">The blog you are looking for does not exist or has been removed.</p>
                    <Link to="/blogs" className="btn btn-primary">Back to Blogs</Link>
                </div>
                <Footer />
            </div>
        );
    }

    const stripHtml = (html) => {
        if (!html) return '';
        return html.replace(/<[^>]+>/g, '').substring(0, 160) + '...';
    };

    return (
        <div className="main-wrapper">
            <SEO
                title={blog.meta_title || blog.blog_title}
                description={blog.meta_desc || stripHtml(blog.blog_desc)}
                keywords={blog.meta_keywords}
                ogTitle={blog.meta_title || blog.blog_title}
                ogDescription={blog.meta_desc || stripHtml(blog.blog_desc)}
            />
            <Header />
            <div className="blog-detail-container" style={{ minHeight: '60vh', paddingTop: '120px', paddingBottom: '60px' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="blog-detail-header mb-4">
                                <h1>{blog.blog_title}</h1>
                                <div className="blog-meta mt-3 text-muted">
                                    <span className="me-3"><i className="bi bi-calendar-event me-1"></i> {new Date(blog.created_at).toLocaleDateString()}</span>
                                    {blog.category && <span className="badge bg-danger">{blog.category}</span>}
                                </div>
                            </div>
                            <div className="blog-detail-image mb-4">
                                <img
                                    src={blog.image_url || 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80'}
                                    alt={blog.blog_title}
                                    className="img-fluid rounded w-100"
                                />
                            </div>
                            <div className="blog-detail-content" dangerouslySetInnerHTML={{ __html: blog.blog_desc }} />

                            {/* Appended Custom Section */}
                            {/* <div className="custom-blog-section mt-5 p-4 border rounded shadow-sm bg-white"> */}
                            <div className=" mt-5">
                                <h3 className="mb-3 fw-bold" style={{ color: '#222' }}>Unordered & Ordered Lists</h3>
                                <p className="text-muted mb-4" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                    It is advisable to use your network to successfully land a job. Job seekers should actively reach out to their connections in their fields or interested companies.
                                </p>

                                <ul className="custom-check-list mb-5">
                                    <li><i className="bi bi-check-circle-fill text-muted me-2"></i> Your child's interests, likes, dislikes</li>
                                    <li><i className="bi bi-check-circle-fill text-muted me-2"></i> Their routines - patterns of eating, sleeping, toileting</li>
                                    <li><i className="bi bi-check-circle-fill text-muted me-2"></i> Your child's current wellbeing</li>
                                    <li><i className="bi bi-check-circle-fill text-muted me-2"></i> Any major events taking place at home.</li>
                                </ul>

                                <blockquote className="custom-blockquote custom-blog-section shadow-sm bg-white">
                                    <p className="mb-3" style={{ fontSize: '18px', fontStyle: 'italic', color: '#444' }}>
                                        Before Natalia's village had a clean water tap, she often did have time for school. Now, she goes to school every day she presient of her local Water Committee.
                                    </p>
                                    <footer className="text-dark fw-bold" style={{ fontSize: '15px' }}>— Max Conversion</footer>
                                </blockquote>

                                <p className="mt-2 blog-detail-content" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                    It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.
                                    It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.
                                </p>

                            </div>

                            <div className="mt-5 text-center">
                                <Link to="/blogs" className="btn btn-outline-danger">
                                    <i className="bi bi-arrow-left me-2"></i> Back to Blogs
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default BlogDetail;
